import EditIcon from "@mui/icons-material/Edit"
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown"
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp"
import { IconButton, TableCell, TableRow, Tooltip } from "@mui/material"
import { styled } from "@mui/material/styles"
import { useState } from "react"
import { useDispatch } from "react-redux"

import { AppDispatch } from "../../../store"
import { BankState } from "../../../store/actions/bank"
import { openDrawer } from "../../../store/bank/bank-edit-slice"

const BankRow = ({ row }: { row: BankState }) => {
	const dispatch = useDispatch<AppDispatch>()
	const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
	const [openRow, setOpenRow] = useState<boolean>(false)

	const TableCellStyled = styled(TableCell)(() => ({
		paddingLeft: "8px",
	}))

	const handleEditBank = (bank: BankState) => {
		dispatch(openDrawer({ isEditMode: true, bank: bank }))
	}

	return (
		<>
			<TableRow
				hover
				tabIndex={-1}
				key={row.id}
				style={{
					backgroundColor: row.enabled
						? openRow
							? "#F5F7FD"
							: "#FFF"
						: "rgba(211, 211, 211, 0.1)",
				}}
			>
				<TableCellStyled>
					<IconButton
						aria-label="expand row"
						size="small"
						onClick={() => setOpenRow(!openRow)}
					>
						{openRow ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
					</IconButton>
				</TableCellStyled>
				<TableCellStyled component="td" scope="row" padding="none">
					{row.bankName}
				</TableCellStyled>
				<TableCellStyled align="right">{row.timeToExpiry}</TableCellStyled>
				<TableCellStyled align="left">{row.primaryColor}</TableCellStyled>
				<TableCellStyled align="left">{row.secondaryColor}</TableCellStyled>
				<TableCellStyled align="left">
					{Boolean(row.autoAccept) ? "Sì" : "No"}
				</TableCellStyled>
				<TableCellStyled align="left">
					{Boolean(row.checkIban) ? "Sì" : "No"}
				</TableCellStyled>
				<TableCellStyled align="left">
					{Boolean(row.whatsapp) ? "Sì" : "No"}
				</TableCellStyled>
				<TableCellStyled align="center">
					<IconButton color="primary" onClick={() => handleEditBank(row)}>
						<Tooltip title="Modifica configurazione banca">
							<EditIcon />
						</Tooltip>
					</IconButton>
				</TableCellStyled>
			</TableRow>
		</>
	)
}

export default BankRow
